"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const types = require("./types");
exports.createRequest = (workspaceName) => ({
    workspaceName, type: types.CREATE_REQUEST,
});
exports.createSuccess = (workspace) => ({
    workspace, type: types.CREATE_SUCCESS,
});
exports.createFailure = (errorMessage) => ({
    errorMessage, type: types.CREATE_FAILURE,
});
exports.updateRequest = (workspaceId, attributes) => ({
    workspaceId, attributes, type: types.UPDATE_REQUEST,
});
exports.updateSuccess = (workspaceId, workspace) => ({
    workspaceId, workspace, type: types.UPDATE_SUCCESS,
});
exports.updateFailure = (errorMessage) => ({
    errorMessage, type: types.UPDATE_FAILURE,
});
exports.switchActive = (workspaceId) => ({
    workspaceId, type: types.SWITCH_ACTIVE,
});
//# sourceMappingURL=actions.js.map